// export const SERVICE_URL = 'http://localhost:9100';
// export const WS_SERVICE_URL = 'ws://localhost:7666';
export const SERVICE_URL = 'https://api.funboxmusic.com/rest/';
export const WS_SERVICE_URL = 'wss://ws.funboxmusic.com/ws';
// export const SERVICE_URL = 'https://api.routingtales.com/rest/';
// export const WS_SERVICE_URL = 'wss://api.routingtales.com/ws';
